import classnames from "classnames";
import * as React from "react";
import CashoutDisclaimerButton from "../CashoutDisclaimerButton/CashoutDisclaimerButton";
import StatsItem from "../StatsItem/StatsItem";
// tslint:disable-next-line:no-var-requires
const style = require("./StatsPanel.scss");

export interface StatsPanelProps {
    minValue?: number;
    currentValue?: number;
    maxValue?: number;
    maxPrize?: number;
    ticketStake?: number;
    className?: string;
    showDisclaimer?: () => void;
}

export function StatsPanel({
    minValue,
    currentValue,
    maxValue,
    maxPrize,
    showDisclaimer,
    ...props
}: StatsPanelProps) {
    if (
        minValue !== undefined &&
        currentValue !== undefined &&
        maxValue !== undefined &&
        maxPrize !== undefined
    ) {
        return (
            <div className={classnames(style.wrapper, props.className)}>
                <StatsItem value={maxValue} label="MaxEur" />
                <StatsItem value={minValue} label="MinEur" />
                <StatsItem value={currentValue} label="StakeEur" />
                <StatsItem value={maxPrize} label="PossibleWinning" />
                <CashoutDisclaimerButton click={showDisclaimer} />
            </div>
        );
    }
    return null;
}
